<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="!disabled">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('dev_param')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary" v-if="!deviceData.id">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0 && !disabled">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="configurableSlot" slot-scope="text, record">
          <j-switch :options="[1, 0]" @change="enabledConfig(record)" v-model="record.configurable"></j-switch>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-if="!disabled">编辑</a>

          <a-divider type="vertical" v-if="!disabled" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item v-if="!disabled">
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <dev-param-modal :deviceData="deviceData" @ok="modalFormOk" ref="modalForm"></dev-param-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { putAction } from '@/api/manage'
  import DevParamModal from './modules/DevParamModal'

  export default {
    name: 'DevParamList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevParamModal
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        description: '设备参数管理页面',
        // 表头
        columns: [
          {
            title: '参数名称',
            align: 'center',
            dataIndex: 'paramName',
            sorter: true
          },
          {
            title: '编码',
            align: 'center',
            dataIndex: 'paramCode',
            sorter: true
          },
          // {
          //   title: '参数描述',
          //   align: 'center',
          //   dataIndex: 'paramDesc'
          // },
          {
            title: '参数值',
            align: 'center',
            dataIndex: 'defaultValue'
          },
          {
            title: '是否可配置',
            align: 'center',
            dataIndex: 'configurable',
            scopedSlots: { customRender: 'configurableSlot' },
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/device/devParam/list',
          edit: '/device/devParam/edit',
          delete: '/device/devParam/delete',
          deleteBatch: '/device/devParam/deleteBatch',
          exportXlsUrl: '/device/devParam/exportXls',
          importExcelUrl: 'device/devParam/importExcel'
        },
        dictOptions: {},
        superFieldList: [],
        disableMixinCreated: true
      }
    },
    created () {
      if (this.deviceData.id) {
        this.queryParam.devId = this.deviceData.id
      } else if (this.deviceData.devTypeId) {
        this.queryParam.devModelId = this.deviceData.devTypeId
      }
      this.loadData()
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      enabledConfig (record) {
        putAction(this.url.edit, record).then(res => {
          if (res.success) {
            this.searchQuery()
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'paramName', text: '参数名称' })
        fieldList.push({ type: 'string', value: 'paramCode', text: '编码' })
        fieldList.push({ type: 'string', value: 'paramDesc', text: '参数描述' })
        fieldList.push({ type: 'string', value: 'defaultValue', text: '默认值' })
        fieldList.push({ type: 'int', value: 'devId', text: '设备ID' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
